export default __webpack_public_path__ + "static/media/carlos_salinas.5e4b135d.jpeg";